import React from 'react';

import type { PatientIntakeStep } from '@shared/patient-intake-status';

import type { ActionPromptContextType } from './ActionPrompt.types.ts';

const ActionPromptContext = React.createContext<ActionPromptContextType<PatientIntakeStep> | null>(null);

export const useActionPromptContext = (): ActionPromptContextType<PatientIntakeStep> => {
  const context = React.useContext(ActionPromptContext);

  if (!context) {
    throw new Error('useActionPromptContext must be used within an ActionPromptProvider');
  }

  return context as ActionPromptContextType<PatientIntakeStep>;
};

export type ActionPromptProviderProps = {
  children: React.ReactNode;
  value: ActionPromptContextType<PatientIntakeStep>;
};

export const ActionPromptProvider = ({ children, value }: ActionPromptProviderProps) => (
  <ActionPromptContext.Provider value={value}>{children}</ActionPromptContext.Provider>
);
